import React, { useRef } from 'react';
import './Footer.scss';
import { PageFooter,Text } from 'glic-ui-components';
import ContactUsModal from '../ContactUs/ContactUsModal';
import appConstants from '../../utility/appConstants';
import parse from 'html-react-parser';


const Footer = () => {
  const setShowModalRef = useRef(false);
  const handleContact = () => {
    setShowModalRef.current.setModal();
  };
  return (
    <div className="footer">
      <PageFooter
        footerText={[
          <Text disclaimer onDarkBackground>
            {appConstants.DISCLAIMER_ONE}
          </Text>,
          <Text disclaimer onDarkBackground>
            {appConstants.DISCLAIMER_TWO}
          </Text>,
        ]}
        navLinks={{
          menu: [
            {
              links: [
                {
                  label: 'Privacy notice',
                  link: appConstants.PRIVACY_NOTICE,
                  isExternal: true,
                },
                {
                  label: 'Guardian Life',
                  link: appConstants.GUARDIAN_LIFE,
                  isExternal: true,
                },
                {
                  label: 'Contact  us',
                  onClick: (e) => {
                    e.preventDefault();
                    handleContact();
                  },
                },
                {
                  label: 'FAQs',
                  link: appConstants.FAQ_ROUTE,
                  isExternal: true,
                },
              ],
            },
          ],
        }}
        disclaimer={parse(appConstants.DISCLAIMER_TEXT)}
      />
      <div className="contactModal">
        <ContactUsModal setShowModalRef={setShowModalRef} />
      </div>
    </div>
  );
};
export default Footer;